import { Navigate, Route, Routes } from "react-router-dom";
import AgentCreationLogsPage from "./AgentCreationLogs";
import AgentMailboxesPage from "./AgentMailboxes";
import BrainChatLogsPage from "./BrainChatLogs";
import BulkUpdateJobsPage from "./BulkUpdateJobs";
import ConversationLogsPage from "./ConversationLogs";
import DemoGeniesPage from "./DemoGenies";
import EdgeFunctionLogsPage from "./EdgeFunctionLogs";
import EmailLogsPage from "./EmailLogs";
import GenieMeetingsPage from "./GenieMeetings";
import InactiveGeniesPage from "./InactiveGenies";
import PhoneNumbersPage from "./PhoneNumbers";
import PreselectedVoicesPage from "./PreselectedVoices";
import PronunciationVaultsPage from "./PronunciationVaults";
import SlackAppsPage from "./SlackApps";
import SuiteVisitLogsPage from "./SuiteVisitLogs";
import UsersPage from "./Users";
import UserAnalyticsPage from "./Users/Analytics";

const ApplicationManagement = () => {
  return (
    <Routes>
      <Route path="users" element={<UsersPage />} />
      <Route path="users/:userId/analytics" element={<UserAnalyticsPage />} />
      <Route path="agent-mailboxes" element={<AgentMailboxesPage />} />
      <Route path="email-logs" element={<EmailLogsPage />} />
      <Route path="conversation-logs" element={<ConversationLogsPage />} />
      <Route path="genie-meetings" element={<GenieMeetingsPage />} />
      <Route path="phone-numbers" element={<PhoneNumbersPage />} />
      <Route path="agent-creation-logs" element={<AgentCreationLogsPage />} />
      <Route path="bulk-update-jobs" element={<BulkUpdateJobsPage />} />
      <Route path="brain-chat-logs" element={<BrainChatLogsPage />} />
      <Route path="tool-invocations" element={<Navigate to="/admin/brain-chat-logs" replace />} />
      <Route path="core-chat-logs" element={<Navigate to="/admin/brain-chat-logs" replace />} />
      <Route path="suite-visit-logs" element={<SuiteVisitLogsPage />} />
      <Route path="demo-genies" element={<DemoGeniesPage />} />
      <Route path="inactive-genies" element={<InactiveGeniesPage />} />
      <Route path="slack-apps" element={<SlackAppsPage />} />
      <Route path="pronunciation-vaults" element={<PronunciationVaultsPage />} />
      <Route path="preselected-voices" element={<PreselectedVoicesPage />} />
      <Route path="edge-function-logs" element={<EdgeFunctionLogsPage />} />
    </Routes>
  );
};

export default ApplicationManagement;
